module.exports = __webpack_public_path__ + "static/media/gw.c9e312cb.svg";